import { useState } from 'react'
import { PrinterIcon } from '../../ui/icons/PrinterIcon'
import { ButtonComponent } from '../../ui/molecules/button/newButton'
import { MadfarmStaticSelect } from '../../ui/molecules/select/newSelect/static'
import { normativa, yearOptions } from '../../utils'

export function SchedaCalcoloPrint() {
    const [selectedNorm, setSelectedNorm] = useState<string | null>(null)
    const [selectedYear, setSelectedYear] = useState<string | null>(null)

    return (
        <div>
            <div className="m-6 mb-8 rounded-[20px] bg-[#F2F7F7]">
                <div className="bg-brandPrimary-600 px-6 py-4 rounded-t-[24px]">
                    <span className="text-white font-semibold text-xl">Scheda di Calcolo </span>
                    <span className="text-brandPrimary-300">/</span>
                    <span className="text-brandPrimary-100 font-semibold uppercase text-xl"> Stampa</span>
                </div>

                <div className="px-6 py-5 flex flex-col gap-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <MadfarmStaticSelect
                            label="Normativa"
                            placeholder="Specifica normativa..."
                            noOptionsMessage="Nessuna normativa disponibile"
                            options={normativa}
                            value={selectedNorm}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                setSelectedNorm(newValue as string | null)
                            }}
                        />
                        <MadfarmStaticSelect
                            label="Anno"
                            placeholder="Specifica anno..."
                            noOptionsMessage="Nessun anno disponibile"
                            options={yearOptions}
                            value={selectedYear}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                setSelectedYear(newValue as string | null)
                            }}
                        />
                    </div>
                    <div className="flex justify-end">
                        <ButtonComponent
                            variant="solid"
                            color="blue"
                            size="md"
                            iconPosition="left"
                            icon={<PrinterIcon color={''} />}
                            label="Stampa Schede di calcolo"
                            onClick={() => { }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}